export default __webpack_public_path__ + "static/media/Caribbean-lndscpe.a5a605b1.webp";